import React from 'react';
import { Card } from '../ui/Card';
export function RiskMapWidget() {
  const sectorRiskData = [{
    sector: 'Servizi professionali',
    riskScore: 2.7
  }, {
    sector: "Commercio all'ingrosso",
    riskScore: 3.2
  }, {
    sector: 'Trasporti e logistica',
    riskScore: 3.3
  }, {
    sector: 'Agroalimentare',
    riskScore: 3.4
  }, {
    sector: 'Retail/GDO/e-commerce',
    riskScore: 3.8
  }, {
    sector: 'Energia e utilities',
    riskScore: 3.9
  }, {
    sector: 'Edilizia e costruzioni',
    riskScore: 4.0
  }];
  // Sort sectors by risk score (lowest to highest)
  const sortedData = [...sectorRiskData].sort((a, b) => a.riskScore - b.riskScore);
  const getBarColor = score => {
    if (score < 3.0) return 'bg-[#00C853]/70';
    if (score < 3.5) return 'bg-[#FFB84D]/70';
    if (score < 4.0) return 'bg-[#FFB84D]';
    return 'bg-[#FF6B81]';
  };
  return <Card title="Mappa di Rischio per Settore" data-id="element-623">
      <div className="space-y-4" data-id="element-624">
        {sortedData.map((item, index) => <div key={index} className="space-y-1" data-id="element-625">
            <div className="flex justify-between" data-id="element-626">
              <span className="text-sm font-medium" data-id="element-627">{item.sector}</span>
              <span className="text-sm font-medium" data-id="element-628">
                {item.riskScore.toFixed(1)}
              </span>
            </div>
            <div className="w-full bg-gray-100 rounded-full h-2.5" data-id="element-629">
              <div className={`${getBarColor(item.riskScore)} h-2.5 rounded-full`} style={{
            width: `${item.riskScore / 5 * 100}%`
          }} data-id="element-630" />
            </div>
          </div>)}
        <div className="mt-4 pt-3 border-t border-gray-200" data-id="element-631">
          <div className="flex items-center justify-between text-xs text-gray-500" data-id="element-632">
            <span data-id="element-633">Rischio basso (0)</span>
            <span data-id="element-634">Rischio alto (5)</span>
          </div>
          <div className="mt-1 w-full h-1.5 bg-gradient-to-r from-[#00C853]/70 via-[#FFB84D] to-[#FF6B81] rounded-full" data-id="element-635" />
        </div>
      </div>
    </Card>;
}